import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Auth/store/index.js